var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaireFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38 13.833L.666 16.75V1.333A.833.833 0 011.5.5h15a.833.833 0 01.833.833V13a.833.833 0 01-.833.833H4.38zm3.787-4.166v1.666h1.666V9.667H8.167zM6.139 5.344l1.635.328A1.25 1.25 0 119 7.167h-.833v1.666H9a2.917 2.917 0 10-2.86-3.489z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/questionnaire-fill.svg";
export { SvgQuestionnaireFill as ReactComponent };